import { uniqueId } from "lodash-es";

type NotificationType = "success" | "error" | "warning";
export interface NotificationProps {
  text: string;
  type?: NotificationType;
  timeout?: number;
  error?: unknown;
}

export class Notification implements NotificationProps {
  id: string;
  text: string;
  type?: NotificationType;
  timeout?: number | undefined;
  error?: unknown;

  constructor(props: NotificationProps) {
    const DEFAULT_TIMEOUT_IN_MS = 5000;

    this.id = uniqueId("N");
    this.text = props.text;
    this.type = props.type ?? undefined;
    this.timeout = props.timeout ?? DEFAULT_TIMEOUT_IN_MS;
    this.error = props.error ?? undefined;
  }
}
